export const reportStatusOptions = [
  "Fraud",
  "Policy Violation",
  "Negligence",
  "Exclusion",
  "Payable",
  "Inconclusive",
  "Recovery",
];

export const options = [
  "Excellent",
  "Very Good",
  "Good",
  "Fair",
  "Average",
  "Below Average",
];
export const reportStandardValObj = {
  Excellent: 50,
  ["Very Good"]: 42.5,
  Good: 37.5,
  Fair: 30,
  Average: 20,
  ["Below Average"]: 10,
};

export const tabsApproval = [
  {
    label: "Case Approval",
  },
  {
    label: "Invoice Approval",
  },
  {
    label: "Hospital De-Empanelment",
  },
  {
    label: "Garage De-Empanelment",
  },
  {
    label: "Police Complaints",
  },
  {
    label: "Vendor Approval",
  },
  {
    label: "Exclusion List",
  },
  {
    label: "Cautions Tagging",
  },
];

export const tabs2Approval = [
  //1
  {
    headerVal: [
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },
      { label: "FCU Actions" },
      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      // {
      //   label: "Dispatch Details",
      // },
      {
        label: "Claim Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Risk Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
  //2
  {
    headerVal: [
      { label: "FCU Actions" },
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },
      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      // {
      //   label: "Dispatch Details",
      // },
      {
        label: "Claim Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Risk Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
  //3
  {
    headerVal: [
      {
        label: "Recommendation",
      },
      {
        label: "FCU Actions",
      },
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },

      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      // {
      //   label: "Dispatch Deatils",
      // },
      {
        label: "Claim Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Risk Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
  //4

  {
    headerVal: [
      {
        label: "Recommendation",
      },
      {
        label: "FCU Actions",
      },
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },

      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      // {
      //   label: "Dispatch Deatils",
      // },
      {
        label: "Claim Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Risk Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
  //5
  {
    headerVal: [
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },
      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      // {
      //   label: "Dispatch Details",
      // },
      {
        label: "Claim Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Risk Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
  //6
  {
    headerVal: [
      {
        label: "vendor Details",
      },
      {
        label: "Statutory Details",
      },
      {
        label: "Company Reg. No.",
      },
      {
        label: "Bank Details",
      },
      {
        label: "Nature of Firm",
      },
      {
        label: "Upload Doc",
      },
      {
        label: "Product Mapping",
      },
      {
        label: "Sub-Product",
      },
    ],
  },
  // 7 closed
  {
    headerVal: [
      { label: "FCU Actions" },
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },
      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      // {
      //   label: "Dispatch Details",
      // },
      {
        label: "Claim Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Risk Details",
        // icon: (
        //   <svg
        //     width="18"
        //     height="16"
        //     viewBox="0 0 18 16"
        //     fill="none"
        //     xmlns="http://www.w3.org/2000/svg"
        //   >
        //     <path
        //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
        //       fill="#E42125"
        //     />
        //     <path
        //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
        //       fill="#FFFCF2"
        //     />
        //     <path
        //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
        //       fill="#FFFCF2"
        //     />
        //   </svg>
        // ),
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
  // 8 case approval
  {
    headerVal: [
      {
        label: "Investigation",
        border: "1px solid #E7373B",
        bg: "#E8505B",
      },
      { label: "FCU Actions" },
      {
        label: "Basic Details",
      },
      {
        label: "Policy Details",
      },
      {
        label: "Proposal Details",
      },
      {
        label: "Claim Details",
      },
      {
        label: "Risk Details",
      },
      {
        label: "Endorsement Details",
      },
      {
        label: "CHASE Smart",
      },
    ],
  },
];

export const ApprovalTableData = [
  {
    //1
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      // {
      //   id: "customer_type",
      //   label: "Customer Type",
      //   align: "left",
      // },
      // {
      //   id: "Vendor name",
      //   label: "Vendor Name",
      //   align: "left",
      // },
      {
        id: "chase_created_date",
        label: "Chase Created Date",
        align: "left",
      },
      // {
      //   id: "reportSubmissionDate",
      //   label: "Report Submission Date",
      //   align: "left",
      // },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      // {
      //   id: "trigger_source",
      //   label: "Trigger Source",
      //   align: "center",
      // },
      // {
      //   id: "assignedDate",
      //   label: "Assigned Date",
      //   align: "left",
      // },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "sub_product_name",
        label: "Sub Product",
        align: "center",
      },
      {
        id: "severity",
        label: "Severity",
        align: "center",
      },
      {
        id: "tat",
        label: "Over All TAT",
        align: "center",
      },
      {
        id: "created_by",
        label: "Case Created By",
        align: "left",
      },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "left",
      },
      {
        id: "state",
        label: "State",
        align: "center",
      },
      {
        id: "city",
        label: "City",
        align: "center",
      },
      {
        id: "closure_category",
        label: "Investigation Type",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "case_initiator",
        label: "Case Initiator",
        align: "left",
      },
      {
        id: "case_grade",
        label: "Case Grade",
        align: "left",
      },
      {
        id: "last_grade_provider",
        label: "Last Grade Provider",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
      {
        id: "hospital_name",
        label: "Hospital Name",
        align: "left"
      },
      {
        id: "claim_amount",
        label: "Claim Amount",
        align: "left"
      }
    ],
    row: [
      {
        srNo: 5,
        caseNo: 25,
        claimNo: "C2300222 54669",
        customerName: "PARAMESH VERAPPA H ",
        customerType: "HNI",
        vendorName: "RAMESH RAPPA",
        claimRegistrationDate: "02/10/2022",
        reportSubmissionDate: "02/10/2022",
        policyNo: "2300222546 6900000001",
        tiggerSource: "-",
        assignedDate: "02/10/2022",
        lob: "Motor",
        subProduct: "-",
        severity: "REF,MR",
        overAllTat: "-",
        caseCreatedBy: "IM",
        lossLocation: "KARNATAKA",
        state: "-",
        city: "-",
      },
      {
        srNo: 6,
        caseNo: 25,
        claimNo: "C2300222 54669",
        customerName: "PARAMESH VERAPPA H ",
        customerType: "RED Circle",
        vendorName: "RAMESH RAPPA",
        claimRegistrationDate: "02/10/2022",
        reportSubmissionDate: "02/10/2022",
        policyNo: "2300222546 6900000001",
        tiggerSource: "-",
        assignedDate: "02/10/2022",
        lob: "Motor",
        subProduct: "-",
        severity: "REF",
        overAllTat: "-",
        caseCreatedBy: "IM",
        lossLocation: "KARNATAKA",
        state: "-",
        city: "-",
      },
      {
        srNo: 7,
        caseNo: 25,
        claimNo: "C2300222 54669",
        customerName: "PARAMESH VERAPPA H ",
        customerType: "HNI",
        vendorName: "RAMESH RAPPA",
        claimRegistrationDate: "02/10/2022",
        reportSubmissionDate: "02/10/2022",
        policyNo: "2300222546 6900000001",
        tiggerSource: "-",
        assignedDate: "02/10/2022",
        lob: "Motor",
        subProduct: "-",
        severity: "REF,MR",
        overAllTat: "-",
        caseCreatedBy: "IM",
        lossLocation: "KARNATAKA",
        state: "-",
        city: "-",
      },
      {
        srNo: 8,
        caseNo: 25,
        claimNo: "C2300222 54669",
        customerName: "PARAMESH VERAPPA H ",
        customerType: "RED Circle",
        vendorName: "RAMESH RAPPA",
        claimRegistrationDate: "02/10/2022",
        reportSubmissionDate: "02/10/2022",
        policyNo: "2300222546 6900000001",
        tiggerSource: "-",
        assignedDate: "02/10/2022",
        lob: "Motor",
        subProduct: "-",
        severity: "REF",
        overAllTat: "-",
        caseCreatedBy: "IM",
        lossLocation: "KARNATAKA",
        state: "-",
        city: "-",
      },
      {
        srNo: 9,
        caseNo: 25,
        claimNo: "C2300222 54669",
        customerName: "PARAMESH VERAPPA H ",
        customerType: "HNI",
        vendorName: "RAMESH RAPPA",
        claimRegistrationDate: "02/10/2022",
        reportSubmissionDate: "02/10/2022",
        policyNo: "2300222546 6900000001",
        tiggerSource: "-",
        assignedDate: "02/10/2022",
        lob: "Motor",
        subProduct: "-",
        severity: "REF,MR",
        overAllTat: "-",
        caseCreatedBy: "IM",
        lossLocation: "KARNATAKA",
        state: "-",
        city: "-",
      },
    ],
  },
  {
    //2
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      // {
      //   id: "customer_type",
      //   label: "Customer Type",
      //   align: "left",
      // },
      {
        id: "chase_created_date",
        label: "Chase Created Date",
        align: "left",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      // {
      //   id: "trigger_source",
      //   label: "Trigger Source",
      //   align: "left",
      // },
      // {
      //   id: "assigned_date",
      //   label: "Assigned Date",
      //   align: "left",
      // },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "sub_product_name",
        label: "Sub Product",
        align: "center",
      },
      // {
      //   id: "vendor_name",
      //   label: "Vendor Name",
      //   align: "left",
      // },
      {
        id: "ageing",
        label: "Ageing",
        align: "left",
      },
      // {
      //   id: "assigned_to",
      //   label: "Assigned To",
      //   align: "center",
      // },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "center",
      },
      {
        id: "vendor_count",
        label: "Vendor Count",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
    row: [
      {
        srNo: 5,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        customer_type: "HNI",
        claim_registration_date: "02/10/2022",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "Motor",
        sub_product_name: "-",
        vendor_name: "RAMESH RAPPA",
        ageing: "28/11/2022",
        assigned_to: "-",
        loss_location: "KARNATAKA",
      },
      {
        srNo: 6,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        customer_type: "RED Circle",
        claim_registration_date: "02/10/2022",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "Motor",
        sub_product_name: "-",
        vendor_name: "RAMESH RAPPA",
        ageing: "28/11/2022",
        assigned_to: "-",
        loss_location: "KARNATAKA",
      },
      {
        srNo: 7,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        customer_type: "HNI",
        claim_registration_date: "02/10/2022",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "Motor",
        sub_product_name: "-",
        vendor_name: "RAMESH RAPPA",
        ageing: "28/11/2022",
        assigned_to: "-",
        loss_location: "KARNATAKA",
      },
      {
        srNo: 8,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        customer_type: "RED Circle",
        claim_registration_date: "02/10/2022",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "Motor",
        sub_product_name: "-",
        vendor_name: "RAMESH RAPPA",
        ageing: "28/11/2022",
        assigned_to: "-",
        loss_location: "KARNATAKA",
      },
      {
        srNo: 9,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        customer_type: "HNI",
        claim_registration_date: "02/10/2022",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "Motor",
        sub_product_name: "-",
        vendor_name: "RAMESH RAPPA",
        ageing: "28/11/2022",
        assigned_to: "-",
        loss_location: "KARNATAKA",
      },
    ],
  },
  {
    //3
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_number",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      // {
      //   id: "trigger_source",
      //   label: "Trigger Source",
      //   align: "left",
      // },
      {
        id: "assigned_date",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "hospitalcount",
        label: "Hospital Count",
        align: "center",
      },
      {
        id: "location",
        label: "Location",
        align: "center",
      },
      {
        id: "recommendation",
        label: "Recommendation",
        align: "center",
      },
      // {
      //   id: "severity",
      //   label: "Severity",
      //   align: "center",
      // },
      // {
      //   id: "hospital_name",
      //   label: "Hospital Name",
      //   align: "center",
      // },

      // {
      //   id: "hospital_code",
      //   label: "Hospital Code",
      //   align: "center",
      // },
      // {
      //   id: "loss_location",
      //   label: "Loss Location",
      //   align: "center",
      // },

      // {
      //   id: "state",
      //   label: "State",
      //   align: "left",
      // },
      // {
      //   id: "city",
      //   label: "City",
      //   align: "left",
      // },
      // {
      //   id: "recommendation",
      //   label: "Recommendation",
      //   align: "left",
      // },
      {
        id: "qc_status",
        label: "QC Status",
        align: "left",
      },
      {
        id: "reverse_action_status",
        label: "Reverse Action Status",
        align: "left",
      },
      {
        id: "initiated_date",
        label: "Initiated Date",
        align: "left",
      },
      {
        id: "approved_date",
        label: "Approved Date",
        align: "left",
      },
      {
        id: "approved_by",
        label: "Approved By",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],

    row: [
      {
        srNo: 5,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        hospital_count: "1",
        severity: "REF",
        hospital_name: "Fortis",
        location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 6,
        case_id: 26,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        hospital_count: "-",
        severity: "REF",
        hospital_name: "Fortis",
        location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 7,
        case_id: 27,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        hospital_count: "-",
        severity: "REF",
        hospital_name: "Fortis",
        location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 8,
        case_id: 28,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        hospital_count: "-",
        severity: "REF",
        hospital_name: "Fortis",
        location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 9,
        case_id: 29,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        hospital_count: "-",
        severity: "REF",
        hospital_name: "Fortis",
        location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
    ],
  },
  {
    //4
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_number",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      {
        id: "trigger_source",
        label: "Trigger Source",
        align: "left",
      },
      {
        id: "created_at",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "assigned_to",
        label: "Assigned To",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "sub_product",
        label: "Sub Product",
        align: "center",
      },
      {
        id: "severity",
        label: "Severity",
        align: "center",
      },
      // {
      //   id: "garage_name",
      //   label: "Garage Name",
      //   align: "center",
      // },
      // {
      //   id: "garage_location",
      //   label: "Garage Location",
      //   align: "center",
      // },
      // {
      //   id: "garage_code",
      //   label: "Garage Code",
      //   align: "center",
      // },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "center",
      },
      {
        id: "loss_state",
        label: "State",
        align: "left",
      },
      {
        id: "loss_city",
        label: "City",
        align: "left",
      },
      {
        id: "recommendation",
        label: "Recommendation",
        align: "left",
      },
      {
        id: "qc_status",
        label: "QC Status",
        align: "left",
      },
      {
        id: "reverse_action_status",
        label: "Reverse Action Status",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],

    row: [
      {
        srNo: 5,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        assigned_to: "-",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        garage_name: "Fortis",
        garage_location: "KARNATAKA",
        garage_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 6,
        case_id: 26,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        assigned_to: "-",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        garage_name: "Fortis",
        garage_location: "KARNATAKA",
        garage_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 7,
        case_id: 27,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        assigned_to: "-",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        garage_name: "Fortis",
        garage_location: "KARNATAKA",
        garage_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 8,
        case_id: 28,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        assigned_to: "-",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        garage_name: "Fortis",
        garage_location: "KARNATAKA",
        garage_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 9,
        case_id: 29,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        assigned_to: "-",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        garage_name: "Fortis",
        garage_location: "KARNATAKA",
        garage_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
    ],
  },
  {
    //5
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_number",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      {
        id: "trigger_source",
        label: "Trigger Source",
        align: "left",
      },
      {
        id: "created_at",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "sub_product",
        label: "Sub Product",
        align: "center",
      },
      {
        id: "severity",
        label: "Severity",
        align: "center",
      },
      // {
      //   id: "hospital_name",
      //   label: "Hospital Name",
      //   align: "center",
      // },
      // {
      //   id: "hospital_location",
      //   label: "Hospital Location",
      //   align: "center",
      // },
      // {
      //   id: "hospital_code",
      //   label: "Hospital Code",
      //   align: "center",
      // },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "center",
      },

      {
        id: "loss_state",
        label: "State",
        align: "left",
      },
      {
        id: "loss_city",
        label: "City",
        align: "left",
      },
      {
        id: "recommendation",
        label: "Recommendation",
        align: "left",
      },
      {
        id: "qc_status",
        label: "QC Status",
        align: "left",
      },
      {
        id: "reverse_action_status",
        label: "Reverse Action Status",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
    //5
    row: [
      {
        srNo: 5,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        hospital_name: "Fortis",
        hospital_location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 6,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        hospital_name: "Fortis",
        hospital_location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 7,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        hospital_name: "Fortis",
        hospital_location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 8,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        hospital_name: "Fortis",
        hospital_location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
      {
        srNo: 9,
        case_id: 25,
        claim_no: "C2300222 54669",
        customer_name: "PARAMESH VERAPPA H ",
        policy_no: "2300222546 6900000001",
        tigger_source: "-",
        assigned_date: "02/10/2022",
        lob: "clsim type 1",
        product: "Motor",
        sub_product_name: "-",
        severity: "REF",
        hospital_name: "Fortis",
        hospital_location: "KARNATAKA",
        hospital_code: "001",
        loss_location: "KARNATAKA",
        state: "-",
        city: "-",
        recommendation: "-",
        qc_status: "Yes",
        reverse_action_status: "No",
      },
    ],
  },
  {
    //6
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "profile",
        minWidth: "10rem",
        label: "Profile",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "vendorName",
        label: "Vendor Name",
        align: "left",
      },
      {
        id: "vendorState",
        label: "Vendor State",
        align: "left",
      },
      {
        id: "vendorCity",
        label: "Vendor City",
        align: "left",
      },
      {
        id: "vendorCategory",
        label: "Vendor Category",
        align: "center",
      },
      {
        id: "productMapping",
        label: "Product Mapping",
        align: "center",
      },
      {
        id: "capacity",
        label: "Capacity",
        align: "center",
      },
      {
        id: "totalWorkExperience",
        label: "Total Work Experience",
        align: "center",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
    //6
    row: [
      {
        srNo: 5,
        profile: 25,
        vendorName: "RAMESH RAPPA",
        vendorState: "KARNTAKA ",
        vendorCity: "KARNTAKA ",
        vendorCategory: "-",
        productMapping: "-",
        capacity: "-",
        totalWorkExperience: "-",
      },
      {
        srNo: 6,
        profile: 25,
        vendorName: "RAMESH RAPPA",
        vendorState: "KARNTAKA ",
        vendorCity: "KARNTAKA ",
        vendorCategory: "-",
        productMapping: "-",
        capacity: "-",
        totalWorkExperience: "-",
      },
      {
        srNo: 7,
        profile: 25,
        vendorName: "RAMESH RAPPA",
        vendorState: "KARNTAKA ",
        vendorCity: "KARNTAKA ",
        vendorCategory: "-",
        productMapping: "-",
        capacity: "-",
        totalWorkExperience: "-",
      },
      {
        srNo: 8,
        profile: 25,
        vendorName: "RAMESH RAPPA",
        vendorState: "KARNTAKA ",
        vendorCity: "KARNTAKA ",
        vendorCategory: "-",
        productMapping: "-",
        capacity: "-",
        totalWorkExperience: "-",
      },
      {
        srNo: 9,
        profile: 25,
        vendorName: "RAMESH RAPPA",
        vendorState: "KARNTAKA ",
        vendorCity: "KARNTAKA ",
        vendorCategory: "-",
        productMapping: "-",
        capacity: "-",
        totalWorkExperience: "-",
      },
    ],
  },
  {
    //7 Exclusion
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_number",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      // {
      //   id: "trigger_source",
      //   label: "Trigger Source",
      //   align: "left",
      // },
      {
        id: "assigned_date",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "hospitalcount",
        label: "Hospital Count",
        align: "center",
      },
      {
        id: "location",
        label: "Location",
        align: "center",
      },
      {
        id: "recommendation",
        label: "Recommendation",
        align: "center",
      },
      // {
      //   id: "severity",
      //   label: "Severity",
      //   align: "center",
      // },
      // {
      //   id: "hospital_name",
      //   label: "Hospital Name",
      //   align: "center",
      // },

      // {
      //   id: "hospital_code",
      //   label: "Hospital Code",
      //   align: "center",
      // },
      // {
      //   id: "loss_location",
      //   label: "Loss Location",
      //   align: "center",
      // },

      // {
      //   id: "state",
      //   label: "State",
      //   align: "left",
      // },
      // {
      //   id: "city",
      //   label: "City",
      //   align: "left",
      // },
      // {
      //   id: "recommendation",
      //   label: "Recommendation",
      //   align: "left",
      // },
      {
        id: "qc_status",
        label: "QC Status",
        align: "left",
      },
      {
        id: "reverse_action_status",
        label: "Reverse Action Status",
        align: "left",
      },
      {
        id: "initiated_date",
        label: "Initiated Date",
        align: "left",
      },
      {
        id: "approved_date",
        label: "Approved Date",
        align: "left",
      },
      {
        id: "approved_by",
        label: "Approved By",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],

    row: [
      // {
      //   srNo: 5,
      //   case_id: 25,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "1",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 6,
      //   case_id: 26,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 7,
      //   case_id: 27,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 8,
      //   case_id: 28,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 9,
      //   case_id: 29,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
    ],
  },
  {
    //8 Cautions
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_number",
        label: "Claim No.",
        align: "left",
        minWidth: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      // {
      //   id: "trigger_source",
      //   label: "Trigger Source",
      //   align: "left",
      // },
      {
        id: "assigned_date",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "hospitalcount",
        label: "Hospital Count",
        align: "center",
      },
      {
        id: "location",
        label: "Location",
        align: "center",
      },
      {
        id: "recommendation",
        label: "Recommendation",
        align: "center",
      },
      // {
      //   id: "severity",
      //   label: "Severity",
      //   align: "center",
      // },
      // {
      //   id: "hospital_name",
      //   label: "Hospital Name",
      //   align: "center",
      // },

      // {
      //   id: "hospital_code",
      //   label: "Hospital Code",
      //   align: "center",
      // },
      // {
      //   id: "loss_location",
      //   label: "Loss Location",
      //   align: "center",
      // },

      // {
      //   id: "state",
      //   label: "State",
      //   align: "left",
      // },
      // {
      //   id: "city",
      //   label: "City",
      //   align: "left",
      // },
      // {
      //   id: "recommendation",
      //   label: "Recommendation",
      //   align: "left",
      // },
      {
        id: "qc_status",
        label: "QC Status",
        align: "left",
      },
      {
        id: "reverse_action_status",
        label: "Reverse Action Status",
        align: "left",
      },
      {
        id: "initiated_date",
        label: "Initiated Date",
        align: "left",
      },
      {
        id: "approved_date",
        label: "Approved Date",
        align: "left",
      },
      {
        id: "approved_by",
        label: "Approved By",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],

    row: [
      // {
      //   srNo: 5,
      //   case_id: 25,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "1",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 6,
      //   case_id: 26,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 7,
      //   case_id: 27,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 8,
      //   case_id: 28,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
      // {
      //   srNo: 9,
      //   case_id: 29,
      //   claim_no: "C2300222 54669",
      //   customer_name: "PARAMESH VERAPPA H ",
      //   policy_no: "2300222546 6900000001",
      //   tigger_source: "-",
      //   assigned_date: "02/10/2022",
      //   lob: "clsim type 1",
      //   product: "Motor",
      //   hospital_count: "-",
      //   severity: "REF",
      //   hospital_name: "Fortis",
      //   location: "KARNATAKA",
      //   hospital_code: "001",
      //   loss_location: "KARNATAKA",
      //   state: "-",
      //   city: "-",
      //   recommendation: "-",
      //   qc_status: "Yes",
      //   reverse_action_status: "No",
      // },
    ],
  },
];

export const removeElementForBS = [
  "assigned_date",
  "approved_date",
  "approved_by",
];

export const removeElementForRM = ["approved_date", "approved_by"];

export const removeElementForQC = [
  "assigned_date",
  "approved_date",
  "approved_by",
  "initiated_date",
];

export const ApprovalInvestigationAssignedBlocksContents = {
  "Accident Spot Verification": [
    [
      { label: "Whether FIR filed", value: "Yes" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Case Comments": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  Invoice: [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Case Status History": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Insured details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "FIR / GD": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Claimant details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Charge sheet details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Details MVI Reports": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Eye Witness": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Fraud / Supected Fraud / Loss minimization": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "File Submission History": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "Income details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  Invoice: [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "MLC details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "IV Driver details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "IV Permit details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "IV RC details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "IV RC details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "IV Seizure Memo details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
  "IV Policy details": [
    [
      { label: "Whether FIR filed", value: "Case Comments" },
      { label: "FIR Number", value: "12345678/2022" },
      { label: "FIR Date", value: "29/11/2022" },
      { label: "Time of FIR", value: "10:30" },
      { label: "Delay in FIR", value: "123456" },
      { label: "FIR lodged by", value: "abcd1234" },
      {
        label: "Relation of complaint with the petitioner",
        value: "abcd1234",
      },
      {
        label: "Registration No. of the accused vehicle",
        value: "abcd1234",
      },
      { label: "Name of the accused driver", value: "Ashish" },
      { label: "Accused Vehicle", value: "TVP" },
      { label: "FIR against IV / TPV", value: "yes" },
      { label: "Color of the accused crime vehicle", value: "Black" },
      { label: "Name of the police station", value: "Bhandup west" },
      { label: "Charge sheet field", value: "yes" },
      { label: "Name of the driver in petition", value: "Kartik" },
      { label: "District", value: "borivali" },
      { label: "State", value: "Maharashtra" },
      { label: "Name of the investigating officer", value: "Ali" },
      { label: "Reason for delay in FIR", value: "Nothing" },
      { label: "Rank of the investigating officer", value: "ACP" },
      { label: "IPC, MV Act & Others:", value: "IPC" },
    ],
    [
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
      { name: "array", size: "178kb" },
    ],
  ],
};

export const ApprovalInvestigationMainTabs = [
  { label: "Vendor & Blocks" },
  { label: "Investigation Reports" },
  { label: "Invoice" },
  { label: "BS Investigation Reports" },
];

export const ApprovalInvestigationListTabs = [
  { label: "Investigator 1" },
  { label: "Investigator 2" },
  { label: "Investigator 3" },
  { label: "Investigator 4" },
  { label: "Investigator 5" },
  { label: "Investigator 6" },
  { label: "Investigator 7" },
  { label: "Investigator 8" },
  { label: "Investigator 9" },
  { label: "Investigator 10" },
  { label: "Investigator 11" },
  { label: "Investigator 12" },
];

export const ApprovalInvestigationAssignedBlocks = [
  { label: "Accident Spot Verification" },
  { label: "Case Comments" },
  { label: "Case Status History" },
  { label: "FIR / GD" },
  { label: "Insured details" },
  { label: "Claimant details" },
  { label: "Charge sheet details" },
  { label: "Details MVI Reports" },
  { label: "Details MVI Reports" },
  { label: "Eye Witness" },
  { label: "Fraud / Supected Fraud / Loss minimization" },
  { label: "File Submission History" },
  { label: "Income details" },
  { label: "Invoice" },
  { label: "MLC details" },
  { label: "IV Driver details" },
  { label: "IV Permit details" },
  { label: "IV RC details" },
  { label: "IV Seizure Memo details" },
  { label: "IV Policy details" },
];

export const InvestigatorDetailsArray = [
  {
    name: " Paramesh Varappa",
    mobileNumber: 1234567890,
    location: "Karnataka",
    email: "test1@gmail.com",
  },
  {
    name: " kamal",
    mobileNumber: 2345678901,
    location: "uttar pradesh",
    email: "test2@gmail.com",
  },
  {
    name: "panja",
    mobileNumber: 3456789012,
    location: "Karnataka",
    email: "test3@gmail.com",
  },
];

export const InvestigationReportsData = [
  { label: "Vendor 1", investigationStatus: "rejected" },
  { label: "Vendor 2", investigationStatus: "approved" },
  { label: "Vendor 3", investigationStatus: "new vendor" },
  { label: "Vendor 4", investigationStatus: "new vendor" },
  { label: "Vendor 5", investigationStatus: "new vendor" },
  { label: "Vendor 6", investigationStatus: "new vendor" },
  { label: "Vendor 7", investigationStatus: "new vendor" },
  { label: "Vendor 8", investigationStatus: "new vendor" },
  { label: "Vendor 9", investigationStatus: "new vendor" },
];

export const tabValuePairing = {
  Case: "caseList",
  Invoice: "invoiceList",
  Hospital: "hospitalList",
  Garage: "garageList",
  Police: "policeList",
  Exclusion: "hospitalList",
  Cautions: "hospitalList",
};

export const invoiceDetails = {
  fresh_invoice_info: {
    invoice_no: "1234567890",
    invoice_date: "01/01/2023",
    agency_name: "Test ABC Company Pvt. Ltd.",
    claim_no: "1234567890",
    hdfc_ergo_gst_no: "1234ABCD567890",
    gst_no: "1234ABCD567890",
    product_category: "Motor",
    charge_details: {
      "ABCD Test1": 1234567890,
      "ABCD Test2": 1234567890,
      "ABCD Test3": 1234567890,
      "ABCD Test4": 1234567890,
      Total: 9999999999,
    },
    tax_details: {
      CGST: 1234567890,
      SGST: 1234567890,
      UGST: 1234567890,
      Total: 9999999999,
    },
    total_amount: 9999999999,
  },
  previous_invoice_info: {
    invoice_no: "1234567890",
    invoice_date: "01/01/2023",
    agency_name: "Test ABC Company Pvt. Ltd.",
    claim_no: "1234567890",
    hdfc_ergo_gst_no: "1234ABCD567890",
    gst_no: "1234ABCD567890",
    product_category: "Motor",
    charge_details: {
      charges: [
        { "ABCD Test": 1234567890 },
        { "ABCD Test": 1234567890 },
        { "ABCD Test": 1234567890 },
        { "ABCD Test": 1234567890 },
      ],
      Total: 9999999999,
    },
    tax_details: {
      taxes: [{ CGST: 1234567890 }, { SGST: 1234567890 }, { UGST: 1234567890 }],
      Total: 9999999999,
    },
    total_amount: 9999999999,
  },
};

export const bsInfo = {
  bs_employee_id: "-",
  fraud_type: "-",
  bs_role_id: "-",
  description: "-",
  case_status: "-",
  chase_allocation_date: "-",
  findings_submission_date: "-",
  bimasathi_name: "-",
  locations: "-",
  case_grade: "-",
  grade_status: "-",
  grade_sub_status: "-",
};

export const bsInvestigationDocumentsDetails = [
  {
    document_path:
      "https://storage.googleapis.com/hdfcergo-cima-gcs-bucket-documents/1704965130922.pdf?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=gke-service-account%40prj-srv-cima-devb9.iam.gserviceaccount.com%2F20240117%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20240117T061450Z&X-Goog-Expires=120000&X-Goog-SignedHeaders=host&X-Goog-Signature=65a181d723aa09579a7a2d4daeaa07757f9895c0f473b3694c3d734d776cb6da2c61aa673f427c00204fcfee98fe339ff76f0de7ec555177122e1f23acb4c621e7b2b3c3cb20e65173ce0025c5407867f8182a7d799ba767519f4c2a3a82f90ecfe20ba4d43e98d6c72134916e0b7de7a1bb6f166ccf170e551bfa17b066c4b4868ff7af0b808ed73e55fd2baca4385efac25d8693d7ffa6f61b19cbc53d161f3b10e0da8f56f66d9fc3da8e314f9c761918778113fce79005f8f7de9a7cd19a282d6231b070d44d31ce8f511f61edb09d272e0b55a6f2d871643aa771e7c0e295ade04816b873ff3e28dbc9fd616a82ccd07ef45da05140365f193638717b88",
    document_type: "Bills",
    document_name: "1704965130922.pdf",
    mime_type: "pdf",
    document_size: "35.91 KB",
  },
  {
    document_path:
      "https://storage.googleapis.com/hdfcergo-cima-gcs-bucket-documents/1704965130922.pdf?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=gke-service-account%40prj-srv-cima-devb9.iam.gserviceaccount.com%2F20240117%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20240117T061450Z&X-Goog-Expires=120000&X-Goog-SignedHeaders=host&X-Goog-Signature=65a181d723aa09579a7a2d4daeaa07757f9895c0f473b3694c3d734d776cb6da2c61aa673f427c00204fcfee98fe339ff76f0de7ec555177122e1f23acb4c621e7b2b3c3cb20e65173ce0025c5407867f8182a7d799ba767519f4c2a3a82f90ecfe20ba4d43e98d6c72134916e0b7de7a1bb6f166ccf170e551bfa17b066c4b4868ff7af0b808ed73e55fd2baca4385efac25d8693d7ffa6f61b19cbc53d161f3b10e0da8f56f66d9fc3da8e314f9c761918778113fce79005f8f7de9a7cd19a282d6231b070d44d31ce8f511f61edb09d272e0b55a6f2d871643aa771e7c0e295ade04816b873ff3e28dbc9fd616a82ccd07ef45da05140365f193638717b88",
    document_type: "Bills",
    document_name: "1704965130922.pdf",
    mime_type: "pdf",
    document_size: "35.91 KB",
  },
];

export const content = `<p class=\"ql-align-center\"><strong>Description</strong></p><p class=\"ql-align-center\"><br></p><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis optio, recusandae illo velit, mollitia odit fugit molestias voluptate officia, impedit et animi perferendis aut praesentium sapiente? Reprehenderit aut inventore totam iure earum accusantium odio ad voluptas, ab maiores! Unde omnis minus nobis odio aliquam rem praesentium nihil nostrum nam ipsa ducimus excepturi nisi rerum saepe repellat, quae pariatur cum mollitia expedita eos sit. Repellendus iusto dignissimos quae magnam enim repellat eum officia nesciunt tenetur nulla itaque ratione assumenda esse magni est reiciendis commodi velit neque, maiores tempore obcaecati, quibusdam alias architecto ipsam. Quam dicta fugiat sint in aliquid rerum officia, ipsum perspiciatis ipsam perferendis eligendi laborum iusto omnis nobis facilis alias voluptatibus ab? Debitis, cupiditate similique! Nihil asperiores consectetur adipisci dolore, odio nisi architecto omnis quisquam error cum numquam ut assumenda praesentium blanditiis. Non saepe, tenetur sed nam sunt similique hic molestias at accusantium pariatur repellat. Quam ullam officia temporibus laboriosam perferendis libero quas ducimus magni aliquam omnis repudiandae velit sed in debitis obcaecati, porro at ratione!</p><p><br></p><p>\t\t\t<span style=\"color: rgb(58, 58, 58);\">Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis optio, recusandae illo velit, mollitia odit fugit molestias voluptate officia, impedit et animi perferendis aut praesentium sapiente? Reprehenderit aut inventore totam iure earum accusantium odio ad voluptas, ab maiores! Unde omnis minus nobis odio aliquam rem praesentium nihil nostrum nam ipsa ducimus excepturi nisi rerum saepe repellat, quae pariatur cum mollitia expedita eos sit. Repellendus iusto dignissimos quae magnam enim repellat eum officia nesciunt tenetur nulla itaque ratione assumenda esse magni est reiciendis commodi velit neque, maiores tempore obcaecati, quibusdam alias architecto ipsam. Quam dicta fugiat sint in aliquid rerum officia, ipsum perspiciatis ipsam perferendis eligendi laborum iusto omnis nobis facilis alias voluptatibus ab? Debitis, cupiditate similique! Nihil asperiores consectetur adipisci dolore, odio nisi architecto omnis quisquam error cum numquam ut assumenda praesentium blanditiis. Non saepe, tenetur sed nam sunt similique hic molestias at accusantium pariatur repellat. Quam ullam officia temporibus laboriosam perferendis libero quas ducimus magni aliquam omnis repudiandae velit sed in debitis obcaecati, porro at ratione!</span></p><p><br></p><p>\t\t\t<span style=\"color: rgb(58, 58, 58);\">Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis optio, recusandae illo velit, mollitia odit fugit molestias voluptate officia, impedit et animi perferendis aut praesentium sapiente? Reprehenderit aut inventore totam iure earum accusantium odio ad voluptas, ab maiores! Unde omnis minus nobis odio aliquam rem praesentium nihil nostrum nam ipsa ducimus excepturi nisi rerum saepe repellat, quae pariatur cum mollitia expedita eos sit. Repellendus iusto dignissimos quae magnam enim repellat eum officia nesciunt tenetur nulla itaque ratione assumenda esse magni est reiciendis commodi velit neque, maiores tempore obcaecati, quibusdam alias architecto ipsam. Quam dicta fugiat sint in aliquid rerum officia, ipsum perspiciatis ipsam perferendis eligendi laborum iusto omnis nobis facilis alias voluptatibus ab? Debitis, cupiditate similique! Nihil asperiores consectetur adipisci dolore, odio nisi architecto omnis quisquam error cum numquam ut assumenda praesentium blanditiis. Non saepe, tenetur sed nam sunt similique hic molestias at accusantium pariatur repellat. Quam ullam officia temporibus laboriosam perferendis libero quas ducimus magni aliquam omnis repudiandae velit sed in debitis obcaecati, porro at ratione!</span></p>`;
